__turbopack_context__.v({
  "focused": "select-module-scss-module__KfPXdq__focused",
  "my-item": "select-module-scss-module__KfPXdq__my-item",
  "select": "select-module-scss-module__KfPXdq__select",
  "select_icon": "select-module-scss-module__KfPXdq__select_icon",
  "select_list": "select-module-scss-module__KfPXdq__select_list",
  "select_option": "select-module-scss-module__KfPXdq__select_option",
  "select_popover": "select-module-scss-module__KfPXdq__select_popover",
  "select_selectButton": "select-module-scss-module__KfPXdq__select_selectButton",
});
